import { render, staticRenderFns } from "./DocumentData.vue?vue&type=template&id=1e10b968&"
import script from "./DocumentData.vue?vue&type=script&lang=js&"
export * from "./DocumentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports